import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "show-personal-data",
  template: `
    <button class="btn btn-success"
      *ngIf="!data"
      [disabled]=disable 
      (click)="onShow()"
    >{{label}}</button>
    <p *ngIf="data">{{ data }}</p> 
  `,
})
export class ShowPersonalData {
    @Input() label: string;
    @Input() data: string | number;
    @Output() show = new EventEmitter();
    disable = false;

    onShow() {
      this.disable = true;
      this.show.emit()
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/components/show-personal-data.component.ts